import { render, staticRenderFns } from "./StaticAboutUs.vue?vue&type=template&id=30266556&"
import script from "./StaticAboutUs.vue?vue&type=script&lang=js&"
export * from "./StaticAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./StaticAboutUs.vue?vue&type=style&index=0&id=30266556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports